import { ROUTE_APROBAR_SOLICITUD } from './names'
import { permissionTree, RESOURCE_SOLICITUDES } from '@/auth/permissions/modules/solicitudes'
import { defineRoutes } from '@/utils/router'

export default defineRoutes([
    //#region Transacciones
    {
        path: '/solicitudes/transacciones/crear-solicitud',
        name: ROUTE_APROBAR_SOLICITUD,
        component: () => import('@/views/pages/solicitudes/transacciones/CrearSolicitud.vue'),
        meta: {
            title: 'i18n:solicitudes.subopciones.crear_solicitud',
            action: permissionTree.transacciones.aprobarSolicitud,
            resource: RESOURCE_SOLICITUDES,
            pageTitle: 'solicitudes.subopciones.crear_solicitud',
            breadcrumb: [
                {
                    text: 'solicitudes.menu_title',
                },
                {
                    text: 'global.menu.transacciones',
                },
                {
                    text: 'solicitudes.subopciones.crear_solicitud',
                    active: true,
                },
            ],
        },
    },
])
